import type { Domain } from '@/services/domain/types'

interface DomainsState {
  selectedDomain: string
  domains: Domain[]
  totalDomains: number
}

export const domains = {
  namespaced: true,
  state: (): DomainsState => ({
    selectedDomain: '',
    domains: [],
    totalDomains: 0
  }),
  mutations: {
    setDomain(state, domain: Domain) {
      state.selectedDomain = domain
    },
    setDomains(state, domains: Domain[]) {
      state.domains = domains
    },
    setTotal(state, total: number) {
      state.totalDomains = total
    },
    logout(state) {
      state.domains = []
      state.totalDomains = 0
    }
  },
  actions: {
    setDomain(context, domain: Domain) {
      context.commit('setDomain', domain)
    },
    setDomains(context, domains: Domain[]) {
      context.commit('setDomains', domains)
    },
    setTotal(context, total: number) {
      context.commit('setTotal', total)
    },
    reset(context) {
      context.commit('logout')
    }
  }
}
